// 结算单
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self"
                  @reload="$reloadHandle"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">

        <div>
          <vxe-grid show-overflow  :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption"
                    @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle"
                    @checkbox-change="({records}) => selectedData = records"
                    @checkbox-all="({records}) => selectedData = records"
                    :checkbox-config="{ labelField: '', highlight: true, reserve: true , range: true}"
          >
            <template #form>
              <div class="clearfix screen-btns" style=" padding-bottom: 6px;">
                <div class="fl">
                  <!-- <vxe-button  status="primary" class="button-sty" icon="el-icon-bottom" @click="batchImportExcel">批量导入</vxe-button>  -->
                  <vxe-button  v-if="applicationExport" status="primary" class="button-sty" icon="el-icon-top" @click="doExcleDetail">批量导出</vxe-button>
                  <vxe-button  v-if="applicationNotice" status="primary" class="button-sty" icon="el-icon-check" @click="batchNotic('通知',null)">批量通知</vxe-button>
                  <vxe-button  v-if="applicationCancel" status="primary" class="button-sty" icon="el-icon-check" @click="batchCancel">取消结算</vxe-button>
                  <vxe-button  v-if="applicationSettle" status="primary" class="button-sty" icon="el-icon-check" @click="batchSettle('结算完成',null)">结算完成</vxe-button>
                  <vxe-button  v-if="applicationAdjustmentAmount" status="primary" class="button-sty" icon="el-icon-check" @click="doAdjustmentAmount">金额调平</vxe-button>

                  <vxe-button  v-if="zbApplicationUpload && companyShortName == '纽恩泰' && !isSite && isShowUploadInvoice" status="primary" class="button-sty" icon="el-icon-check" @click="batchUploadInvoic">代开发票</vxe-button>
                </div>
                <div class="fr" style="display: flex;">
<!--                  <el-input placeholder="请输入结算单号" style="width: 200px;     height: 27px !important;"-->
<!--                            v-model="searchValue" clearable>-->
<!--                    &lt;!&ndash; <i slot="prefix" class="el-input__icon el-icon-search"></i> &ndash;&gt;-->
<!--                  </el-input>-->
                  <el-input type="textarea"
                            :autosize="{ minRows: 1, maxRows: 3}" style="width: 200px;     height: 27px !important; " @keyup.enter.native="searchEvent"
                            v-model="searchValue" placeholder="请输入结算单号" clearable>
                    <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
                  </el-input>
                  <vxe-button status="warning" icon="el-icon-search" style="margin: 0 1px;"
                              class="button-sty" @click="searchEvent">搜索
                  </vxe-button>
                  <div style="display: flex;margin-top: 5px;margin-right: 5px;color: #409eff;" @click="show3 = !show3">
                    <svg t="1682558973727" class="icon" viewBox="0 0 1024 1024" version="1.1"
                         xmlns="http://www.w3.org/2000/svg" p-id="1587" width="16" height="16">
                      <path
                        d="M921.6 686.08h-245.76c-10.24 0-20.48-10.24-20.48-20.48s10.24-20.48 20.48-20.48H921.6c10.24 0 20.48 10.24 20.48 20.48s-10.24 20.48-20.48 20.48z m0-122.88h-245.76c-10.24 0-20.48-10.24-20.48-20.48s10.24-20.48 20.48-20.48H921.6c10.24 0 20.48 10.24 20.48 20.48s-10.24 20.48-20.48 20.48z m-166.4-289.28c-2.56 2.56-243.2 227.84-243.2 227.84v389.12l-163.84-81.92v-307.2L112.64 281.6c-2.56-2.56-5.12-5.12-7.68-5.12-15.36-15.36-23.04-35.84-23.04-58.88 0-46.08 38.4-84.48 84.48-84.48h527.36c46.08 0 84.48 38.4 84.48 84.48 0 23.04-10.24 43.52-23.04 56.32zM693.76 179.2H166.4C145.92 179.2 128 197.12 128 217.6c0 10.24 2.56 20.48 10.24 25.6l2.56 2.56 227.84 215.04 15.36 12.8 2.56 25.6-2.56 273.92 81.92 40.96V473.6l15.36-12.8 230.4-212.48 2.56-2.56c7.68-7.68 10.24-15.36 10.24-25.6 7.68-23.04-10.24-40.96-30.72-40.96z m-17.92 588.8H921.6c10.24 0 20.48 10.24 20.48 20.48s-10.24 20.48-20.48 20.48h-245.76c-10.24 0-20.48-10.24-20.48-20.48 0-12.8 7.68-20.48 20.48-20.48z"
                        fill="#0ea2f0" p-id="1588"></path>
                    </svg>
                    <span>更多筛选</span>
                  </div>

                </div>
              </div>
              <el-collapse-transition name="fade">

                <vxe-form v-show="show3" ref="form" class="screen-box" title-width="7vw"
                          title-align="right" :data="formData" @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent" >
                  <vxe-form-item title="状态:" field="name">
                    <template v-slot>
                      <el-select v-model="formData.stat" :disabled="goodsStatusItem!=='所有'" clearable  style="width:9vw ;">
                        <el-option :value="null" label="全部"></el-option>
                        <el-option :value="1" label="结算生成"></el-option>
                        <el-option :value="2" label="待确认"></el-option>
                        <el-option :value="3" label="已确认"></el-option>
                        <el-option :value="4" label="异议"></el-option>
                        <el-option :value="11" label="待开票"></el-option>
                        <el-option :value="13" label="已开票"></el-option>
                        <el-option :value="15" label="已收票"></el-option>
                        <el-option :value="29" label="已结算"></el-option>
                        <el-option :value="99" label="取消"></el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="工单号:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.orderNo" size="small"  style="width:9vw ;" clearable/>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="服务中心:" field="name">
                    <template v-slot>
                      <org-search :org-name.sync="formData.orgName"
                                  :org-id-path.sync="formData.orgIdPath"
                                  :org-id.sync="formData.orgId"
                                  :show="!currentIsSite"
                                  style="width:9vw ;"
                      />
                    </template>
                    <!-- <template v-slot>
                      <el-input v-model="formData.orgId" size="small"  style="width:9vw ;" clearable>
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="showPreconditionDialog = true"></i>
                      </el-input>
                    </template> -->
                  </vxe-form-item>
                  <vxe-form-item title="服务商:" field="name">
                    <template v-slot>
                      <el-autocomplete
                        class="inline-input"  style="width:9vw ;"
                        v-model="formData.siteName"
                        :fetch-suggestions="querySiteSearch"
                        placeholder="请输入内容"
                        :trigger-on-focus="false"
                        @select="handleSiteSelect"
                      ></el-autocomplete>
                    </template>
                  </vxe-form-item>


                  <vxe-form-item title="创建时间:" field="name">
                    <template v-slot>
                      <el-date-picker style="width: 17vw;" v-model="formData.createDate" type="daterange" align="right" unlink-panels
                                      range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                                      :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                      </el-date-picker>
                    </template>
                  </vxe-form-item>


                  <vxe-form-item title="考核单号:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.checkNo" size="small"  style="width:9vw ;" clearable/>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="发票号:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.invoiceNo" size="small"  style="width:9vw ;" clearable/>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="付款申请单号:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.applyNo" size="small"  style="width:9vw ;" clearable/>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="付款单号:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.applyPayNo" size="small"  style="width:9vw ;" clearable/>
                    </template>
                  </vxe-form-item>

                </vxe-form>
              </el-collapse-transition>

              <div class="goodsStatus">
                <div v-for="(item, index) in goodsStatusList" :key="index">
                  <div :class="{
											btnGoodsStatusBt1: goodsStatusIndex == index,
											btnGoodsStatusBt: goodsStatusIndex != index
										}" @click="changeGoodsStatus(item, index)">
                    <span>{{ item.name }}</span>
                     <span v-if='item.name!=="所有"' class="num_color" >{{ item.num }}</span>
                  </div>
                </div>
              </div>

            </template>
            <template #amountShow="{row}">
<!--                <span v-if="isSite">*</span>-->
                <span>{{ row.amount }}</span>
              </template>
            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
            <!-- 操作 -->
            <template #option="{row}">
              <a href="javascript:void(0);" class="a-link" @click="openEditDialog(row.id, 'edit')">
                <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                            popper-class="tooltip-skin">
                  <i class="el-icon-edit"/>
                </el-tooltip>
              </a>

              <el-dropdown @command="handleCommand($event, row)">
                <span class="el-dropdown-link">
                  <i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="异议处理" v-if="applicationHandle && row.stat==4">异议处理</el-dropdown-item>
                  <el-dropdown-item command="调整金额" v-if="applicationAdjust && (row.stat==1||row.stat==2||row.stat==3||row.stat==4)">调整金额</el-dropdown-item>
                  <el-dropdown-item command="收票" v-if="applicationInvoice && row.stat==13">收票</el-dropdown-item>
                  <el-dropdown-item command="驳回" v-if="applicationReject && row.stat==13">驳回</el-dropdown-item>

<!--                  <el-dropdown-item command="导出流水" v-if="applicationExport">导出流水</el-dropdown-item>-->
                  <el-dropdown-item command="确认" v-if="applicationConfirm && row.stat==2">确认</el-dropdown-item>
<!--                  <el-dropdown-item command="上传发票" v-if="applicationUpload && row.stat==11 && isSite">上传发票</el-dropdown-item>-->
                  <el-dropdown-item command="付款申请" v-if="applicationUpload && row.stat==11 && isSite">付款申请</el-dropdown-item>
<!--                  <el-dropdown-item command="代开发票" v-if="zbApplicationUpload && row.stat==11 && companyShortName == '纽恩泰' && !isSite">代开发票</el-dropdown-item>-->
                </el-dropdown-menu>
              </el-dropdown>

            </template>

          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      title="提示" :visible.sync="dialogVisible" width="30%" >
        <span>{{dialogMsg}}</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirm">确 定</el-button>
        </span>
    </el-dialog>

    <preconditionDialog v-if="showPreconditionDialog" :visiable.sync="showPreconditionDialog" multi="true"/>
    <preconditionDialog2 v-if="showPreconditionDialog2" :visiable.sync="showPreconditionDialog2" multi="true"/>
    <!-- 异议处理 -->
    <objectionHandlingDialog v-if="applicationHandleDialog" :id="currentRowId"
                             :visiable.sync="applicationHandleDialog" multi="true"
                             @goBackIndex="goBackIndex" />

    <!-- 驳回发票 -->
    <applicationRejectDialog v-if="applicationRejectDialog" :id="currentRowId"
                             :visiable.sync="applicationRejectDialog" multi="true"
                             @goBackIndex="goBackIndex" />

    <!-- 调整金额 -->
    <adjustAmountDialog v-if="applicationAdjustDialog" :id="currentRowId"
                             :visiable.sync="applicationAdjustDialog" multi="true"
                             @goBackIndex="goBackIndex" />
    <!-- 确认 -->
    <confirmDialog v-if="applicationConfirmDialog" :id="currentRowId"
                             :visiable.sync="applicationConfirmDialog" multi="true"
                             @goBackIndex="goBackIndex" />
    <!-- 上传发票 -->
    <uploadInvoiceDialog v-if="applicationInvoiceDialog" :id="currentRowId"
                             :visiable.sync="applicationInvoiceDialog" multi="true"
                             @goBackIndex="goBackIndex" />

    <!-- 批量上传发票 -->
    <batchUploadInvoiceDialog v-if="batchInvoiceDialog" :ids="ids"
                         :visiable.sync="batchInvoiceDialog" multi="true"
                         @goBackIndex="goBackIndex" />

    <!-- 批量通知 -->
    <batchPassDialog :param="{idList: currentRow.idList, type: currentRow.type}"
                      v-if="showBatchPassDialog"
                      :visiable.sync="showBatchPassDialog"
                      @goBackIndex="goBackIndex"
                      multi="true"/>
    <!-- 结算完成 -->
    <batchSettleDialog :param="{idList: currentRow.idList, type: currentRow.type}"
                      v-if="showBatchSettleDialog"
                      :visiable.sync="showBatchSettleDialog"
                      @goBackIndex="goBackIndex"
                      multi="true"/>
    <!-- 取消结算 -->
    <batchCancelDialog :param="{idList: currentRow.idList, type: currentRow.type}"
                      v-if="showBatchCancelDialog"
                      :visiable.sync="showBatchCancelDialog"
                      @goBackIndex="goBackIndex"
                      multi="true"/>

  </div>
</template>

<script>
import editView from './edit.vue';
import preconditionDialog from './dialog';
import preconditionDialog2 from './dialog2.vue';
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import {mapGetters} from "vuex";
import api from "@/api/projectApi";
import objectionHandlingDialog from '@/views/finance/cost/application/handlingDialog.vue';
import adjustAmountDialog from '@/views/finance/cost/application/adjustAmountDialog.vue';
import confirmDialog from '@/views/finance/cost/application/confirmDialog.vue';
import uploadInvoiceDialog from '@/views/finance/cost/application/invoiceDialog.vue';

import batchUploadInvoiceDialog from '@/views/finance/cost/application/batchInvoiceDialog.vue';
import batchPassDialog from '@/views/finance/cost/application/batchPassDialog.vue';
import batchSettleDialog from '@/views/finance/cost/application/batchSettleDialog.vue';
import batchCancelDialog from '@/views/finance/cost/application/batchCancelDialog.vue';
import OrgSearch from "@/components/formItem/orgSearch.vue";

import applicationRejectDialog from '@/views/finance/cost/application/rejectDialog.vue';
import { formatTplSimple } from 'echarts/lib/util/format';
import request from "@/router/axios";
import store from "@/store";
import {indexPageMixins, siteMixins} from "@/mixins/tabChang";
import {
  doCheckExcle,
  doDownLoadExcle,
  doDownLoadExcleWithoutRecord,
  getBlob
} from "@/api/intfDownloadRecord/downloadRecord";
import fileNames from "@/api/intfDownloadRecord/fileNames";

export default {
  name: 'application',

  inject: ['reload'],
  mixins: [indexPageMixins,siteMixins],
  components: {editView, pager, preconditionDialog, preconditionDialog2,
    objectionHandlingDialog,adjustAmountDialog,confirmDialog,uploadInvoiceDialog,
    batchPassDialog,batchSettleDialog,batchCancelDialog,OrgSearch,applicationRejectDialog,batchUploadInvoiceDialog},
  data() {
    return {
      isShowUploadInvoice: false,
      applicationAdjustmentAmount:false,
      ids: [],
      isSite: false,
      companyShortName: null,
      total: 0,
      searchValue: null,
      showPage: false,
      applicationHandleDialog: false,
      applicationCancelDialog: false,
      applicationAdjustDialog: false,
      applicationInvoiceDialog: false,
      applicationSettleDialog: false,
      applicationConfirmDialog: false,
      applicationRejectDialog: false,
      applicationInvoice: false,
      applicationReject: false,

      showBatchPassDialog: false,
      showBatchSettleDialog: false,
      showBatchCancelDialog: false,
      batchInvoiceDialog: false,

      first: true,

      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量

        stat: null,
        orderNo: null,
        orgId: null,
        siteId: null,
        checkNo: null,
        invoiceNo: null,
        fuzzySearchIsEnable: false,
        fuzzySearchValue: null,
        createDate: null,
        createTimeBegin: null,
        createTimeEnd: null,
        applyNo:null,
        applyPayNo:null,
      },

      formData: {
        stat: null,
        orderNo: null,
        orgId: null,
        orgIdPath: null,
        orgName: null,
        siteId: null,
        checkNo: null,
        invoiceNo: null,
        settleNo:null,
        createDate: null,
        siteName: null,
        createTimeBegin: null,
        createTimeEnd: null,
        applyNo:null,
        applyPayNo:null,
      },
      show3: false,

      sitePromptList: [],
      goodsStatusList: [],//循环列表
      goodsStatusItem: "",//获取点击的元素名称
      goodsStatusIndex: 0,//:class做判断用，默认选中第一个
      dialogMsg: null,
      dialogVisible: false,
      input: '',
      showPreconditionDialog: false,
      //  取消执行
      showPreconditionDialog2: false,


      pickerOptions: {

        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      value2: '',
      value3: '',
      value: '',
      activeName: 'second',
      dataId: 0,

      vxeOption: {},
      // 查询参数


      pageSizes: [10, 20, 100],
      showEdit: false,
      columns: [
        {type: 'checkbox', width: 30, title: '', resizable: false, fixed: 'left'},
        {width: 100, field: 'status', fixed: 'right', title: '操作', showOverflow: true, slots: {default: 'option'}},
        { title: '结算单号', field: 'settleNo', width: 190, slots: {
            // 使用 JSX 渲染
            default: ({row}) => {
              return [
                <span style="color: blue"
                      onClick={($event) => this.addressClickEvent(row, $event)}>{row.settleNo}</span>
              ]
            }
          }
        },
        { title: '状态', field: 'stat', width: 130, slots: {
            default: ({row}) => {
              if (row.stat == 1) {
                return [
                  <div class="txt-status ">
                    <span>结算生成</span>
                  </div>
                ];
              } else if (row.stat == 2) {
                return [
                  <div class="txt-status neutral">
                    <span>待确认</span>
                  </div>
                ];
              } else if (row.stat == 3) {
                return [
                  <div class="txt-status ">
                    <span>已确认</span>
                  </div>
                ];
              } else if (row.stat == 4) {
                return [
                  <div class="txt-status neutral">
                    <span>异议</span>
                  </div>
                ];
              } else if (row.stat == 11) {
                return [
                  <div class="txt-status neutral">
                    <span>待开票</span>
                  </div>
                ];
              } else if (row.stat == 13) {
                return [
                  <div class="txt-status ">
                    <span>已开票</span>
                  </div>
                ];
              } else if (row.stat == 15) {
                return [
                  <div class="txt-status ">
                    <span>已收票</span>
                  </div>
                ];
              } else if (row.stat == 29) {
                return [
                  <div class="txt-status ">
                    <span>已结算</span>
                  </div>
                ];
              } else if (row.stat == 99) {
                return [
                  <div class="txt-status disable">
                    <span>取消</span>
                  </div>
                ];
              }
            }
          }
        },
        { title: '服务中心',field: 'orgName', width: 100,},
        { title: '服务商', field: 'siteName', width: 100, },
        { title: '总金额', field: 'amount', width: 80, slots: {default: 'amountShow'}},
        { title: '创建人', field: 'createBy', width: 80, },
        { title: '创建时间', field: 'createTime', width: 150, },
      ]
    };
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.getTableData()
      }
    },
    'formData.siteName': {
      handler(newVal) {
        if (!newVal) {
          this.formData.siteId = null
        }
      },
      deep: true
    },

    'formData.createDate': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.createTimeBegin = newVal[0]
          this.formData.createTimeEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.createTimeBegin = null
          this.formData.createTimeEnd = null
        }
      },
      deep: true,
    },
  },
  created() {
    this.applicationHandle = this.permissions["applicationHandle"];
    this.applicationCancel = this.permissions["applicationCancel"];
    this.applicationAdjust = this.permissions["applicationAdjust"];
    this.applicationInvoice = this.permissions["applicationInvoice"];
    this.applicationSettle = this.permissions["applicationSettle"];
    this.applicationExport = this.permissions["applicationExport"];
    this.applicationReject = this.permissions["applicationReject"];
    this.applicationNotice = this.permissions["applicationNotice"];
    this.applicationConfirm = this.permissions["applicationConfirm"];
    this.applicationUpload = this.permissions["applicationUpload"];
    this.zbApplicationUpload = this.permissions["zbApplicationUpload"];
    this.applicationAdjustmentAmount = this.permissions["applicationAdjustmentAmount"];
    this.getCompanyMsg();

    const userInfo = store.getters.userInfo;
    console.log("网点信息:-------",store.getters.userInfo)
    if (userInfo.snUserId) {
      this.isSite = true;
    }
    console.log("是否为服务商" + this.isSite)
  },

  mounted() {
    // this.loadTabOption()
    this.initSearchDate()
  },

  methods: {
    //导出明细
    doExcleDetail() {
      // 获取当前时间
      const now = new Date();
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();

      // 计算当前分钟数，用于精确判断
      const currentMinutes = currentHour * 60 + currentMinute;

      // 早上7点(420分钟) 到 晚上9点(1260分钟) 之间禁止使用
      const startForbiddenMinutes = 7 * 60;   // 7:00
      const endForbiddenMinutes = 21 * 60;    // 21:00

      // 检查是否在禁止时间段内
      if (currentMinutes >= startForbiddenMinutes && currentMinutes < endForbiddenMinutes) {
        this.$message.error('当前时间段（早上7点到晚上9点）禁止执行此操作，请在非工作时间再试！');
        // return; // 直接返回，不执行后续代码
      }

      this.$mask.open();
      doDownLoadExcleWithoutRecord(api.sfBatchSettle.getListByExcelForListUrl, this.requestParam)
        .then((res) => {
          getBlob(res, fileNames.batchSettleListLine);
          this.$mask.close();
        })
        .catch(() => {
          this.$mask.close();
        });
    },
    toFilterData() {
            this.searchEvent();
     },
    getCompanyMsg() {
      request({
        url: '/basic/soOrderIssue/getCompanyMsg',
        method: 'post',
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.companyShortName = response.data.data.companyShortName
        console.log("对应厂商信息1-------",response.data.data)
      })
    },
    goBackIndex(){
      this.getTableData()
      this.flushed()
    },
    // 初始化搜索时间
    // initSearchDate() {
    //   let end = new Date();
    //   let start = new Date();
    //   start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
    //   this.formData.createTime = [start, end]
    // },
    initSearchDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      this.formData.createDate = [start, end]
      this.requestParam.createTimeBegin = start
      this.requestParam.createTimeEnd = end
    },

    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
      this.loadTabOption()
    },

    confirm() {
      this.$http({
        url: api.sfBatchSettle.invoiceDataUrl,
        method: 'post',
        data: {
          id: this.currentRowId,
          stat: this.stat
        }
      }).then(res => {
        this.$message.success('操作成功')
        this.flushed()
      })
      this.dialogVisible = false
    },

    // 服务商提示选中
    handleSiteSelect(data) {
      console.log('selectData', data)
      this.formData.siteId = data.id
    },

    // 获取服务商提示
    querySiteSearch(queryStr, callback) {
      this.$http({
        url: api.snUser.getPromptDataUrl,
        method: 'post',
        data: {userName: queryStr}
      }).then(res => {
        console.log(res.data.data, '网点提示内容')
        let temp = []
        res.data.data.forEach(item => {
          temp.push({value: item.userName, id: item.id})
        })
        callback(temp)
      })
    },

    serviceTypeHandleChange(data) {
      console.log('选中的服务类型数据', data)
    },
    // 加载tab数据
    async loadTabOption() {
      await this.$http({
        url: api.sfBatchSettle.getCountUrl,
        method: 'post',
        data: this.requestParam
      }).then(res => {
        this.goodsStatusList = res.data.data
        if (this.first) {
          this.initSearchDate()
          this.requestParam.stat = this.goodsStatusList[0].stat
          this.formData.stat = this.goodsStatusList[0].stat
        }
        this.first = false
        // this.goodsStatusList = res.data.data
        // if (this.goodsStatusList != null && this.goodsStatusList.length > 0) {
        //   let item = this.goodsStatusList[0]
        //   let temp = null
        //   if (item.name === '待通知') {
        //     temp = 1
        //   } else if (item.name === '待确认') {
        //     temp = 2
        //   } else if (item.name === '有异议') {
        //     temp = 4
        //   } else if (item.name === '待收票') {
        //     temp = 13
        //   } else if (item.name === '待结算') {
        //     temp = 15
        //   }
        //   this.requestParam.stat = temp
        //   this.formData.stat = temp
        // }
        // this.showPage = true
      })
    },

    // 选中的按钮
    changeGoodsStatus(item, index) {
      this.goodsStatusItem = item.name;//获取点击的元素
      this.goodsStatusIndex = index;//将点击元素的下标和：class中的作对比

      let temp = null
      if (item.name === '待通知') {
        temp = 1
      } else if (item.name === '待确认') {
        temp = 2
      } else if (item.name === '有异议') {
        temp = 4
      } else if (item.name === '待开票') {
        temp = 11
      } else if (item.name === '待收票') {
        temp = 13
      } else if (item.name === '待结算') {
        temp = 15
      }
      if(item.name === '待开票'){
        this.isShowUploadInvoice = true;
      }else {
        this.isShowUploadInvoice = false;
      }
      this.requestParam.stat = temp
      this.formData.stat = temp

      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.getTableData()
    },


    // 加载table数据
    async getTableData() {
      await this.loadTabOption()
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.sfBatchSettle.getPageDataUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },

    // 搜索
    searchEvent() {
      this.requestParam.fuzzySearchIsEnable = !this.show3

      let formData = this.formData;
      this.requestParam.fuzzySearchValue = this.searchValue
      this.requestParam.stat = formData.stat
      this.requestParam.orderNo = formData.orderNo
      this.requestParam.orgId = formData.orgId
      this.requestParam.siteId = formData.siteId
      this.requestParam.checkNo = formData.checkNo
      this.requestParam.invoiceNo = formData.invoiceNo

      this.requestParam.createTimeBegin = formData.createTimeBegin
      this.requestParam.createTimeEnd = formData.createTimeEnd

      // if (formData.createTime != null && formData.createTime.length === 2) {
      //   this.requestParam.createTimeBegin = formData.createTime[0]
      //   this.requestParam.createTimeEnd = formData.createTime[1]
      // }

      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.getTableData()
    },

    // 操作
    handleCommand(command, row) {
      this.currentRowId = row.id
      console.log(command, row, "command,b的值");
      if (command === '异议处理') {
        this.applicationHandleDialog = true
      } else if (command === '调整金额') {
        this.applicationAdjustDialog = true
      }else if (command === '收票') {
        this.dialogMsg = '确定收票吗？'
        this.stat = 1
        this.dialogVisible = true
      }else if (command === '结算完成') {
        this.applicationSettle()
      }else if (command === '取消结算') {
        this.applicationCancelDialog = true
      }else if(command === '确认'){
        this.applicationConfirmDialog = true
      }else if(command === '上传发票'){
        this.applicationInvoiceDialog = true
      }else if(command === '驳回'){
        this.applicationRejectDialog = true
      }else if(command === '代开发票'){
        this.applicationInvoiceDialog = true
      }else if(command ==='付款申请'){
        this.$router.push({ path: '/finance/settleApply/index', query: { settleId: row.id } })
      }

    },

     //批量通知
     batchNotic(type, rowId) {
      let reqData = {idList: [], type: null}
      if (type === '通知') {
        reqData.idList.push(...this.selectedData)
        reqData.type = '通知'
      }
      this.currentRow = reqData
      this.showBatchPassDialog = true
    },
    // 结算完成
    batchSettle(type, rowId) {
      let reqData = {idList: [], type: null}
      if (type === '结算完成') {
        reqData.idList.push(...this.selectedData)
        reqData.type = '结算完成'
      }
      this.currentRow = reqData
      this.showBatchSettleDialog = true
    },

    // 取消结算
    batchCancel(){
      let reqData = {idList: [], type: null}
      reqData.idList.push(...this.selectedData)
      reqData.type = '取消结算'
      this.currentRow = reqData
      this.showBatchCancelDialog = true
    },
    //金额调平
    doAdjustmentAmount(){
      let reqData = {idList: [], type: null}
      if (!this.selectedData){
        this.$message.error('请先选择需要金额调平的单据！')
        return
      }
      reqData.idList.push(...this.selectedData)
      this.currentRow = reqData

      this.$baseConfirm('您确定要金额调平吗？').then(() => {
        this.$mask.open()
          this.$http({
            url: api.sfBatchSettle.doAdjustmentAmountUrl,
            method: 'post',
            data: this.currentRow
          }).then(res => {
            if(res.data.type == "success"){
              //网点完工
              this.$mask.close()
              this.flushed()
            }
          })
      })
    },

    //代开发票
    batchUploadInvoic(){
      let reqData = {idList: [], type: null}
      try {
        reqData.idList.push(...this.selectedData)
      }catch (error){
        this.$message.error('请先选择需要批量代开的单据！')
        return
      }
      let ids = [];
      for (let i = 0; i < reqData.idList.length; i++) {
        ids.push(reqData.idList[i].id)
      }
      if (ids.length == 0) {
        this.$message.error('请先选择需要批量代开的单据！')
        return
      }
      this.ids = ids;
      this.batchInvoiceDialog = true
    },

    //收票
    applicationInvoice(){
      this.$http({
          url: api.sfBatchSettle.invoiceDataUrl,
          method: 'post',
          data: this.formData
        }).then(res => {
          this.$message.success('操作成功')
          this.dialogClose()
          this.$emit('goBackIndex')
        })
    },

    dialogClose() {
      this.visiable = false
      this.$emit('update:visiable', this.visiable)
    },

    // 复选框选中
    selectChangeEvent({records}) {
      console.log("数据",records)
      this.selectedData = records
    },

    // 详情显示
    showInfo(row, $event) {
      this.openEditDialog(row.id, 'info')
    },


    // 重置
    resetEvent() {
      this.formData = {
        feeType: '',
        name: ''
      }

      this.requestParam.searchCount = false
      this.requestParam.current = 1
      this.requestParam.name = ''
      this.requestParam.feeType = ''

      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    ///////////////////////////////////////////////////////////////////////////////////////////////////

    // 选中的按钮
    addressClickEvent(row, id) {
      this.openEditDialog(row.id);
      console.log(row, id, "row");
    },
    // 考核备注
    open() {
      this.$prompt('请填写考核备注', '备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        //   inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        //   inputErrorMessage: '邮箱格式不正确'
      }).then(({value}) => {
        this.$message({
          type: 'success',
          message: '你的添加的考核备注是: ' + value
        });
        this.reload()// 需要刷新页面
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
        this.reload()// 需要刷新页面
      });

    },
    // 打开考核弹窗
    // handleCommand(command, b) {
    //   console.log(command, b, "command,b的值");
    //   this.$message('click on item ' + b);
    //   if (b == 1) {
    //     this.showPreconditionDialog = true;
    //   } else if (b == 2) {
    //     this.open()
    //   }
    // },
    // 打开执行考核弹窗
    // handleCommand2(command, b) {
    //   console.log(command, b, "command,b的值");
    //   this.$message('click on item ' + b);
    //   if (b == 1) {
    //     this.showPreconditionDialog2 = true;
    //   } else if (b == 2) {
    //     this.open()
    //   }
    // },
    open() {
      this.$prompt('请填写考核备注', '备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        //   inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        //   inputErrorMessage: '邮箱格式不正确'
      }).then(({value}) => {
        this.$message({
          type: 'success',
          message: '你的添加的考核备注是: ' + value
        });
        this.reload()// 需要刷新页面
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
        this.reload()// 需要刷新页面
      });

    },
    optionChange(value, target) {
      console.log(111, "11111111");
      console.log(value);
      // var select = document.querySelectorAll(".status_select");
      console.log('接受的option的值1', target)
      // var grade = select.options[select.selectedIndex].value;
      // alert(grade);
      // console.log(grade, "grade的值");
      if (target == 2) {
        this.open()
      }
    },

    gradeChange() {
      console.log(11, "11111111111");
      var objS = document.getElementById("pid");
      var grade = objS.options[objS.selectedIndex].grade;
      alert(grade);
      console.log(grade);
    },


    // 新增
    openEditDialog(id) {

      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
      console.log('触发了跳转');
    },


  }
};
</script>
<style lang="scss" scoped>
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

::v-deep .vxe-grid .screen-btns {
  // margin-bottom: 6px;
  border-bottom: 1px solid #ededed !important;
}

.vxe-grid .a-link {
  color: #00c4b3;
  margin-right: 0px !important;
}

// 弹窗过渡显示效果
// 进场时候过渡的开始状态和离场的结束状态
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 指定过渡的属性和时间，同样是进场和离场的过渡时间
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

// 进场时候过渡的结束状态和离场的开始状态
.fade-enter-to,
.fade-leave {
  opacity: 1;
}


// 选中的按钮

.goodsStatus {
  //按钮水平
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-content: space-between;
}

.btnGoodsStatusBt {
  //白底按钮
  // width: 100px;
  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  text-align: center;
  background: #fff;
  padding: 5px;
}

.btnGoodsStatusBt1 {
  //红底按钮
  // width: 100px;
  margin-right: 20px;

  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  color: #409eff;
  text-align: center;
  border-bottom: 3px solid #409eff;
  padding: 5px;
}

.num_color {
  display: inline-block;
  margin-left: 5px;
  /* width: 15px; */
  font-size: 12px;
  padding: 4px;
  line-height: 7px;
  height: 12px;
  color: #409eff;
  border-radius: 4px 4px;
  background-color: #ddeaff;
}

// 隐藏搜索框 标题的宽度
.vxe-grid .vxe-form--item .vxe-form--item-title .vxe-form--item-title-label {
  font-size: 12px;
  display: inline-block;
  width: 65px !important;
}


.active1 {
  // height: 100vh;
  height: calc(100vh - 77px);
  padding-bottom: 29px !important;
}

.no-active2 {
  height: calc(100vh - 70px);
  padding-bottom: 43px !important;
}

#avue-view {
  overflow: unset !important;
}

.avue-view {
  overflow: unset !important;

}

// ::v-deep .vxe-grid .vxe-pager {
//     font-size: 12px;
//     height: 25px !important;
// 	// overflow: hidden;
// }
::v-deep .el-collapse-item__wrap {
  will-change: height;
  background-color: #FFF;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: none !important;
}

::v-deep .el-collapse-item__header {
  height: 0px;
  line-height: 0px;
  border: none !important;
}

::v-deep .el-collapse-item__header.is-active {
  border-bottom: none;
}

::v-deep .el-collapse {
  border-top: 1px solid #002c93;
  border-bottom: 1px solid #EBEEF5;
  border: none;
}

::v-deep .el-collapse-item__arrow {
  position: relative;
  top: -140px;
  font-size: 18px;
  color: #0077ff;
}

::v-deep .vxe-grid .vxe-form--item-title .vxe-form--item-title-content {
  -webkit-box-flex: 1;
  display: inline-block;
  width: 55px;
  -ms-flex-positive: 1;
  flex-grow: 1;
}
// 隐藏搜索栏
.screen-box{
  display: flex;



}
::v-deep .vxe-grid .vxe-form.screen-box {
    padding: 4px 10px 2px 0;
    }

::v-deep .vxe-grid .el-input .el-input__inner {
    height: 28px !important;
}
</style>
